import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
// import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
let sex = class sex extends Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    // private catalogList: any[] = [];
    // private editSortDialogKey = Math.random();
    this.postForm = {
      title: "请选择患者性别",
      itemScore: 0,
      required: "1",
      optionContentType: "TEXT",
      optionsList: [{
        value: "male",
        content: "男",
        rightOption: true,
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        },
        id: 0
      }, {
        value: "female",
        content: "女",
        rightOption: false,
        otherInput: false,
        jsonConfig: {
          openPoint: false,
          pointValue: undefined
        },
        id: 1
      }],
      catalogIds: [],
      whetherJoinQuestionBank: false,
      scoreRule: "",
      jsonConfig: {
        scoreRule: "SAME",
        openPoint: false,
        showIndex: true,
        otherInputForm: "NONE",
        otherInputNumberMin: null,
        otherInputNumberMax: null,
        otherInputNumberPrecision: null,
        otherInputMin: null,
        otherInputMax: null,
        selectRangeMin: null,
        selectRangeMax: null
      }
    };
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      coontent: [{
        required: false,
        type: "string",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get communityType() {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams() {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType
    };
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  // remoteMethod(query?: any) {
  //   this.loading = true;
  //   getCatalog({ ...this.basicParams, name: query, pageSize: 50, pageNum: 1 })
  //     .then((res: any) => {
  //       this.catalogList = res.rows || [];
  //     })
  //     .finally(() => (this.loading = false));
  // }
  // catalogFocus() {
  //   if (this.catalogList.length === 0) {
  //     this.remoteMethod();
  //   }
  // }
  openSortDialog() {
    this.$refs.editSortDialog.onShow({
      isBusinessTypeDisable: true,
      formData: {
        businessType: this.questionnaireType
      }
    });
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], sex.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], sex.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], sex.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], sex.prototype, "watchPostForm", null);
sex = __decorate([Component({
  name: "sex",
  components: {
    questionSettingTemplate
  }
})], sex);
export default sex;